import { formatDate } from 'date-fns'
import { useEffect, useRef } from 'react'

type ElapsedDurationProps = {
  startTime: Date | undefined
}

export const ElapsedDuration = ({ startTime }: ElapsedDurationProps) => {
  const rafRef = useRef<number>(undefined)
  const displayRef = useRef<HTMLSpanElement>(null)
  const formatTime = (startTime: Date) =>
    formatDate(Date.now() - startTime.getTime(), 'mm:ss')

  const updateElapsedTime = () => {
    if (displayRef.current && startTime) {
      displayRef.current.textContent = formatTime(startTime)
    }
    rafRef.current = requestAnimationFrame(updateElapsedTime)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: only on mount/unmount
  useEffect(() => {
    rafRef.current = requestAnimationFrame(updateElapsedTime)
    return () => cancelAnimationFrame(rafRef.current!)
  }, [])

  return (
    <span
      ref={displayRef}
      css={theme => ({
        fontWeight: 700,
        color: startTime
          ? theme.semantic.ColorContentDefault
          : theme.semantic.ColorContentDisabled,
      })}
    >
      {startTime ? formatTime(startTime) : '00:00'}
    </span>
  )
}
